import { render, staticRenderFns } from "./TournamentPayoutsLayout.vue?vue&type=template&id=c09dcaae&"
import script from "./TournamentPayoutsLayout.vue?vue&type=script&lang=js&"
export * from "./TournamentPayoutsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports